module.exports = __webpack_public_path__ + "img/dku.02267.ce4310a1.png";